import { Beer } from '../state/types';

// Extended mock beer data for the beer festival app - 150 beers
// Sorted alphabetically by brewery name, then by beer name within each brewery
export const mockBeers150: Beer[] = [
  {
    id: "bollington-bollington-best",
    number: 1,
    name: "Bollington Best",
    brewery: "Bollington Brewing Co",
    abv: 4.2,
    style: "Best Bitter",
    tags: ["balanced", "traditional", "malty"],
    availability: "available",
    tastingNotes: "A traditional best bitter with perfect balance of malt and hop character.",
    type: "beer"
  },
  {
    id: "bollington-east-indiaman",
    number: 2,
    name: "East Indiaman",
    brewery: "Bollington Brewing Co",
    abv: 5.7,
    style: "IPA",
    tags: ["hoppy", "traditional", "balanced"],
    availability: "available",
    tastingNotes: "A traditional IPA inspired by the historic beers that traveled to India.",
    type: "beer"
  },
  {
    id: "bollington-festival",
    number: 3,
    name: "Festival Ale",
    brewery: "Bollington Brewing Co",
    abv: 4.2,
    style: "Bitter",
    tags: ["balanced", "traditional", "sessionable"],
    availability: "available",
    tastingNotes: "A balanced, sessionable bitter brewed specially for the beer festival.",
    type: "beer"
  },
  {
    id: "bollington-gritstone",
    number: 4,
    name: "Gritstone",
    brewery: "Bollington Brewing Co",
    abv: 4.6,
    style: "Bitter",
    tags: ["earthy", "balanced", "traditional"],
    availability: "available",
    tastingNotes: "A traditional bitter inspired by the local gritstone landscape.",
    type: "beer"
  },
  {
    id: "bollington-happy-valley",
    number: 5,
    name: "Happy Valley",
    brewery: "Bollington Brewing Co",
    abv: 4.7,
    style: "Golden Ale",
    tags: ["balanced", "honey", "refreshing"],
    availability: "available",
    tastingNotes: "A balanced golden ale named after the local valley, with subtle honey notes.",
    type: "beer"
  },
  {
    id: "bollington-long-hop",
    number: 6,
    name: "Long Hop",
    brewery: "Bollington Brewing Co",
    abv: 3.9,
    style: "Session IPA",
    tags: ["hoppy", "citrus", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing session IPA with citrus and tropical fruit notes.",
    type: "beer"
  },
  {
    id: "bollington-long-hop-extra",
    number: 7,
    name: "Long Hop Extra",
    brewery: "Bollington Brewing Co",
    abv: 5,
    style: "IPA",
    tags: ["hoppy", "citrus", "strong"],
    availability: "available",
    tastingNotes: "A stronger version of the popular Long Hop with extra hop character.",
    type: "beer"
  },
  {
    id: "bollington-macclesfield",
    number: 8,
    name: "Macclesfield Pale",
    brewery: "Bollington Brewing Co",
    abv: 4.3,
    style: "Pale Ale",
    tags: ["hoppy", "citrus", "balanced"],
    availability: "available",
    tastingNotes: "A well-balanced pale ale celebrating the local town with bright citrus hop notes.",
    type: "beer"
  },
  {
    id: "bollington-mill-race",
    number: 9,
    name: "Mill Race",
    brewery: "Bollington Brewing Co",
    abv: 3.8,
    style: "Session Bitter",
    tags: ["balanced", "traditional", "sessionable"],
    availability: "available",
    tastingNotes: "A sessionable bitter inspired by the town's mill heritage.",
    type: "beer"
  },
  {
    id: "bollington-mow-cop",
    number: 10,
    name: "Mow Cop",
    brewery: "Bollington Brewing Co",
    abv: 5,
    style: "Strong Bitter",
    tags: ["malty", "balanced", "traditional"],
    availability: "available",
    tastingNotes: "A strong bitter named after the local landmark, with perfect balance.",
    type: "beer"
  },
  {
    id: "bollington-night-porter",
    number: 11,
    name: "Night Porter",
    brewery: "Bollington Brewing Co",
    abv: 5.6,
    style: "Porter",
    tags: ["chocolate", "coffee", "roasty"],
    availability: "available",
    tastingNotes: "A robust porter with rich chocolate and coffee notes.",
    type: "beer"
  },
  {
    id: "bollington-oatmill-stout",
    number: 12,
    name: "Oatmill Stout",
    brewery: "Bollington Brewing Co",
    abv: 5,
    style: "Stout",
    tags: ["oatmeal", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth oatmeal stout with rich chocolate notes.",
    type: "beer"
  },
  {
    id: "bollington-vale-pale",
    number: 13,
    name: "Vale Pale",
    brewery: "Bollington Brewing Co",
    abv: 4.4,
    style: "Pale Ale",
    tags: ["hoppy", "floral", "balanced"],
    availability: "available",
    tastingNotes: "A well-balanced pale ale with floral hop notes and a clean finish.",
    type: "beer"
  },
  {
    id: "bollington-viaduct",
    number: 14,
    name: "Viaduct Strong",
    brewery: "Bollington Brewing Co",
    abv: 5.5,
    style: "Strong Ale",
    tags: ["rich", "malty", "warming"],
    availability: "available",
    tastingNotes: "A strong ale named after the iconic local viaduct, with rich malt character.",
    type: "beer"
  },
  {
    id: "bollington-white-nancy",
    number: 15,
    name: "White Nancy",
    brewery: "Bollington Brewing Co",
    abv: 4.7,
    style: "Pale Ale",
    tags: ["crisp", "citrus", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp pale ale named after the local landmark, with bright citrus notes.",
    type: "beer"
  },
  {
    id: "bollington-white-nancy-extra",
    number: 16,
    name: "White Nancy Extra",
    brewery: "Bollington Brewing Co",
    abv: 5.5,
    style: "Strong Pale",
    tags: ["hoppy", "strong", "citrus"],
    availability: "available",
    tastingNotes: "A stronger version of the popular pale ale with more hop character.",
    type: "beer"
  },
  {
    id: "dunham-massey-barleywine",
    number: 17,
    name: "Barleywine",
    brewery: "Dunham Massey Brewing Co",
    abv: 8.5,
    style: "Barleywine",
    tags: ["strong", "rich", "complex"],
    availability: "available",
    tastingNotes: "A rich, complex barleywine with notes of dried fruit and caramel.",
    type: "beer"
  },
  {
    id: "dunham-massey-blueberry",
    number: 18,
    name: "Blueberry Ale",
    brewery: "Dunham Massey Brewing Co",
    abv: 4,
    style: "Fruit Beer",
    tags: ["fruity", "sweet", "refreshing"],
    availability: "available",
    tastingNotes: "A refreshing ale with subtle blueberry flavor and aroma.",
    type: "beer"
  },
  {
    id: "dunham-chocolate-cherry",
    number: 19,
    name: "Chocolate Cherry Mild",
    brewery: "Dunham Massey Brewing Co",
    abv: 3.8,
    style: "Fruit Beer",
    tags: ["chocolate", "cherry", "sweet"],
    availability: "available",
    tastingNotes: "A mild ale with subtle chocolate and cherry notes.",
    type: "beer"
  },
  {
    id: "dunham-massey-chocolate-orange",
    number: 20,
    name: "Chocolate Orange Stout",
    brewery: "Dunham Massey Brewing Co",
    abv: 5,
    style: "Stout",
    tags: ["chocolate", "orange", "rich"],
    availability: "available",
    tastingNotes: "A rich stout with chocolate and orange notes that work perfectly together.",
    type: "beer"
  },
  {
    id: "dunham-massey-dark-secret",
    number: 21,
    name: "Dark Secret",
    brewery: "Dunham Massey Brewing Co",
    abv: 5.5,
    style: "Stout",
    tags: ["coffee", "chocolate", "complex"],
    availability: "available",
    tastingNotes: "A rich stout with complex coffee and chocolate notes.",
    type: "beer"
  },
  {
    id: "dunham-massey-deer",
    number: 22,
    name: "Deer Beer",
    brewery: "Dunham Massey Brewing Co",
    abv: 4.5,
    style: "Amber Ale",
    tags: ["malty", "nutty", "balanced"],
    availability: "not_ready",
    tastingNotes: "An amber ale with nutty malt character named after the local deer park.",
    type: "beer"
  },
  {
    id: "dunham-massey-dunham-dark",
    number: 23,
    name: "Dunham Dark",
    brewery: "Dunham Massey Brewing Co",
    abv: 4.5,
    style: "Dark Mild",
    tags: ["malty", "smooth", "light"],
    availability: "available",
    tastingNotes: "A smooth dark mild with subtle malt sweetness and a light body.",
    type: "beer"
  },
  {
    id: "dunham-massey-porter",
    number: 24,
    name: "Dunham Porter",
    brewery: "Dunham Massey Brewing Co",
    abv: 5.2,
    style: "Porter",
    tags: ["roasty", "chocolate", "coffee"],
    availability: "available",
    tastingNotes: "A robust porter with notes of dark chocolate and freshly brewed coffee.",
    type: "beer"
  },
  {
    id: "dunham-massey-gold",
    number: 25,
    name: "Gold",
    brewery: "Dunham Massey Brewing Co",
    abv: 4,
    style: "Golden Ale",
    tags: ["light", "crisp", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp, refreshing golden ale with a clean finish.",
    type: "beer"
  },
  {
    id: "dunham-massey-honey",
    number: 26,
    name: "Honey Beer",
    brewery: "Dunham Massey Brewing Co",
    abv: 4.8,
    style: "Golden Ale",
    tags: ["honey", "sweet", "floral"],
    availability: "available",
    tastingNotes: "A golden ale brewed with local honey for subtle sweetness and floral notes.",
    type: "beer"
  },
  {
    id: "dunham-massey-raspberry",
    number: 27,
    name: "Raspberry Wheat",
    brewery: "Dunham Massey Brewing Co",
    abv: 4.2,
    style: "Fruit Beer",
    tags: ["fruity", "wheat", "refreshing"],
    availability: "available",
    tastingNotes: "A refreshing wheat beer with subtle raspberry flavor and aroma.",
    type: "beer"
  },
  {
    id: "dunham-massey-rye",
    number: 28,
    name: "Rye Beer",
    brewery: "Dunham Massey Brewing Co",
    abv: 4.7,
    style: "Rye Beer",
    tags: ["spicy", "malty", "complex"],
    availability: "available",
    tastingNotes: "A complex beer brewed with rye for added spicy malt character.",
    type: "beer"
  },
  {
    id: "dunham-massey-vanilla",
    number: 29,
    name: "Vanilla Stout",
    brewery: "Dunham Massey Brewing Co",
    abv: 5.2,
    style: "Stout",
    tags: ["vanilla", "creamy", "smooth"],
    availability: "available",
    tastingNotes: "A smooth, creamy stout with rich vanilla character.",
    type: "beer"
  },
  {
    id: "dunham-massey-winter",
    number: 30,
    name: "Winter Warmer",
    brewery: "Dunham Massey Brewing Co",
    abv: 6,
    style: "Strong Ale",
    tags: ["rich", "warming", "spicy"],
    availability: "not_ready",
    tastingNotes: "A rich, warming strong ale with subtle spice notes perfect for cold winter evenings.",
    type: "beer"
  },
  {
    id: "lymm-bridge-49",
    number: 31,
    name: "Bridge 49",
    brewery: "Lymm Brewing Co",
    abv: 4.3,
    style: "Golden Ale",
    tags: ["crisp", "floral", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp golden ale named after the local canal bridge, with subtle floral notes.",
    type: "beer"
  },
  {
    id: "lymm-bridgewater",
    number: 32,
    name: "Bridgewater",
    brewery: "Lymm Brewing Co",
    abv: 4.2,
    style: "Bitter",
    tags: ["balanced", "caramel", "traditional"],
    availability: "available",
    tastingNotes: "A balanced bitter with caramel notes named after the historic canal.",
    type: "beer"
  },
  {
    id: "lymm-canal-boat",
    number: 33,
    name: "Canal Boat",
    brewery: "Lymm Brewing Co",
    abv: 4.4,
    style: "Bitter",
    tags: ["traditional", "balanced", "malty"],
    availability: "available",
    tastingNotes: "A traditional bitter inspired by the canal boats that pass through Lymm.",
    type: "beer"
  },
  {
    id: "lymm-cheshire-hop",
    number: 34,
    name: "Cheshire Hop",
    brewery: "Lymm Brewing Co",
    abv: 4.5,
    style: "Pale Ale",
    tags: ["hoppy", "local", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale showcasing locally grown Cheshire hops.",
    type: "beer"
  },
  {
    id: "lymm-dam-dark",
    number: 35,
    name: "Dam Dark",
    brewery: "Lymm Brewing Co",
    abv: 4.5,
    style: "Dark Ale",
    tags: ["malty", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth dark ale with subtle chocolate notes and a clean finish.",
    type: "beer"
  },
  {
    id: "lymm-heritage-cider",
    number: 36,
    name: "Heritage Cider",
    brewery: "Lymm Brewing Co",
    abv: 6,
    style: "Cider",
    tags: ["apple", "traditional", "dry"],
    availability: "available",
    tastingNotes: "A traditional dry cider made with heritage apple varieties.",
    type: "cider"
  },
  {
    id: "lymm-lymm-gold",
    number: 37,
    name: "Lymm Gold",
    brewery: "Lymm Brewing Co",
    abv: 4.4,
    style: "Golden Ale",
    tags: ["light", "crisp", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp, refreshing golden ale with a clean finish.",
    type: "beer"
  },
  {
    id: "lymm-pear-cider",
    number: 38,
    name: "Lymm Perry",
    brewery: "Lymm Brewing Co",
    abv: 5.5,
    style: "Perry",
    tags: ["pear", "sweet", "refreshing"],
    availability: "available",
    tastingNotes: "A sweet perry made with locally grown pears.",
    type: "cider"
  },
  {
    id: "lymm-slaters-bridge",
    number: 39,
    name: "Slater's Bridge",
    brewery: "Lymm Brewing Co",
    abv: 4.7,
    style: "Amber Ale",
    tags: ["malty", "caramel", "balanced"],
    availability: "available",
    tastingNotes: "A balanced amber ale with rich caramel malt character named after a local landmark.",
    type: "beer"
  },
  {
    id: "lymm-strawberry-cider",
    number: 40,
    name: "Strawberry Fields",
    brewery: "Lymm Brewing Co",
    abv: 4,
    style: "Fruit Cider",
    tags: ["strawberry", "sweet", "fruity"],
    availability: "available",
    tastingNotes: "A sweet fruit cider with fresh strawberry flavor and aroma.",
    type: "cider"
  },
  {
    id: "lymm-sweet-cider",
    number: 41,
    name: "Sweet Canal Cider",
    brewery: "Lymm Brewing Co",
    abv: 4.5,
    style: "Cider",
    tags: ["apple", "sweet", "refreshing"],
    availability: "available",
    tastingNotes: "A sweet, refreshing cider perfect for enjoying by the canal.",
    type: "cider"
  },
  {
    id: "lymm-tranquil",
    number: 42,
    name: "Tranquil",
    brewery: "Lymm Brewing Co",
    abv: 3.8,
    style: "Session IPA",
    tags: ["light", "hoppy", "easy"],
    availability: "available",
    tastingNotes: "A light session IPA perfect for relaxed drinking by the canal.",
    type: "beer"
  },
  {
    id: "lymm-village",
    number: 43,
    name: "Village Ale",
    brewery: "Lymm Brewing Co",
    abv: 4.2,
    style: "Golden Ale",
    tags: ["balanced", "honey", "refreshing"],
    availability: "available",
    tastingNotes: "A balanced golden ale celebrating the village of Lymm.",
    type: "beer"
  },
  {
    id: "merlin-apprentice",
    number: 44,
    name: "Apprentice",
    brewery: "Merlin Brewing Co",
    abv: 3.7,
    style: "Session Ale",
    tags: ["light", "balanced", "sessionable"],
    availability: "available",
    tastingNotes: "A light, sessionable ale perfect for those just beginning their beer journey.",
    type: "beer"
  },
  {
    id: "merlin-camelot",
    number: 45,
    name: "Camelot",
    brewery: "Merlin Brewing Co",
    abv: 4.2,
    style: "Golden Ale",
    tags: ["balanced", "honey", "floral"],
    availability: "available",
    tastingNotes: "A golden ale with delicate honey and floral notes.",
    type: "beer"
  },
  {
    id: "merlin-crystal-ball",
    number: 46,
    name: "Crystal Ball",
    brewery: "Merlin Brewing Co",
    abv: 5,
    style: "Crystal Wheat",
    tags: ["wheat", "clear", "refreshing"],
    availability: "available",
    tastingNotes: "A clear wheat beer that defies tradition - you can see your future in it.",
    type: "beer"
  },
  {
    id: "merlin-dragon",
    number: 47,
    name: "Dragon's Breath",
    brewery: "Merlin Brewing Co",
    abv: 6.5,
    style: "Red Ale",
    tags: ["spicy", "rich", "warming"],
    availability: "available",
    tastingNotes: "A fiery red ale with warming alcohol and spicy hop character.",
    type: "beer"
  },
  {
    id: "merlin-enchanted",
    number: 48,
    name: "Enchanted",
    brewery: "Merlin Brewing Co",
    abv: 4.5,
    style: "Golden Ale",
    tags: ["balanced", "floral", "refreshing"],
    availability: "available",
    tastingNotes: "A balanced golden ale with enchanting floral hop notes.",
    type: "beer"
  },
  {
    id: "merlin-excalibur",
    number: 49,
    name: "Excalibur",
    brewery: "Merlin Brewing Co",
    abv: 5.5,
    style: "IPA",
    tags: ["hoppy", "strong", "citrus"],
    availability: "available",
    tastingNotes: "A bold IPA with strong citrus hop character and a dry finish.",
    type: "beer"
  },
  {
    id: "merlin-potion",
    number: 50,
    name: "Magic Potion",
    brewery: "Merlin Brewing Co",
    abv: 6,
    style: "IPA",
    tags: ["hoppy", "strong", "citrus"],
    availability: "available",
    tastingNotes: "A strong IPA with magical citrus hop character that will cast a spell on you.",
    type: "beer"
  },
  {
    id: "merlin-wand",
    number: 51,
    name: "Magic Wand",
    brewery: "Merlin Brewing Co",
    abv: 4.5,
    style: "Pale Ale",
    tags: ["hoppy", "citrus", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale with citrus hop notes that will cast a spell on you.",
    type: "beer"
  },
  {
    id: "merlin-mystic",
    number: 52,
    name: "Mystic",
    brewery: "Merlin Brewing Co",
    abv: 4.6,
    style: "Session IPA",
    tags: ["hoppy", "citrus", "light"],
    availability: "available",
    tastingNotes: "A light session IPA with mystical citrus hop character.",
    type: "beer"
  },
  {
    id: "merlin-round-table",
    number: 53,
    name: "Round Table",
    brewery: "Merlin Brewing Co",
    abv: 4.2,
    style: "Session Bitter",
    tags: ["balanced", "traditional", "sessionable"],
    availability: "available",
    tastingNotes: "A sessionable bitter perfect for gathering around with friends.",
    type: "beer"
  },
  {
    id: "merlin-sorcerer",
    number: 54,
    name: "Sorcerer",
    brewery: "Merlin Brewing Co",
    abv: 4.5,
    style: "Amber Ale",
    tags: ["malty", "caramel", "balanced"],
    availability: "available",
    tastingNotes: "A magical amber ale with rich caramel malt character.",
    type: "beer"
  },
  {
    id: "merlin-spell-binder",
    number: 55,
    name: "Spell Binder",
    brewery: "Merlin Brewing Co",
    abv: 4.3,
    style: "Pale Ale",
    tags: ["hoppy", "floral", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale with floral hop notes that will cast a spell on your taste buds.",
    type: "beer"
  },
  {
    id: "merlin-sword",
    number: 56,
    name: "Sword in the Stone",
    brewery: "Merlin Brewing Co",
    abv: 5.8,
    style: "Strong Ale",
    tags: ["rich", "malty", "legendary"],
    availability: "available",
    tastingNotes: "A legendary strong ale with rich malt character - only the worthy can handle it.",
    type: "beer"
  },
  {
    id: "merlin-wizard",
    number: 57,
    name: "Wizard",
    brewery: "Merlin Brewing Co",
    abv: 4.7,
    style: "Pale Ale",
    tags: ["hoppy", "fruity", "balanced"],
    availability: "sold_out",
    tastingNotes: "A balanced pale ale with fruity hop character and a clean finish.",
    type: "beer"
  },
  {
    id: "mobberley-backbone",
    number: 58,
    name: "Backbone",
    brewery: "Mobberley Brewhouse",
    abv: 4.2,
    style: "Session IPA",
    tags: ["hoppy", "citrus", "light"],
    availability: "available",
    tastingNotes: "A light-bodied session IPA with bright citrus hop character.",
    type: "beer"
  },
  {
    id: "mobberley-big-citra",
    number: 59,
    name: "Big Citra",
    brewery: "Mobberley Brewhouse",
    abv: 6,
    style: "IPA",
    tags: ["citrus", "hoppy", "juicy"],
    availability: "available",
    tastingNotes: "A bold IPA showcasing the juicy, citrus character of Citra hops.",
    type: "beer"
  },
  {
    id: "mobberley-big-tree",
    number: 60,
    name: "Big Tree",
    brewery: "Mobberley Brewhouse",
    abv: 4,
    style: "Session IPA",
    tags: ["hoppy", "light", "piney"],
    availability: "available",
    tastingNotes: "A light session IPA with subtle pine notes named after the village's famous oak.",
    type: "beer"
  },
  {
    id: "mobberley-black-ipa",
    number: 61,
    name: "Black IPA",
    brewery: "Mobberley Brewhouse",
    abv: 5.5,
    style: "Black IPA",
    tags: ["hoppy", "roasty", "complex"],
    availability: "available",
    tastingNotes: "A complex black IPA combining hoppy IPA character with roasty dark malt notes.",
    type: "beer"
  },
  {
    id: "mobberley-boom-juice",
    number: 62,
    name: "Boom Juice",
    brewery: "Mobberley Brewhouse",
    abv: 6.2,
    style: "IPA",
    tags: ["hoppy", "tropical", "strong"],
    availability: "available",
    tastingNotes: "A juicy, hop-forward IPA with tropical fruit flavors and a smooth finish.",
    type: "beer"
  },
  {
    id: "mobberley-century",
    number: 63,
    name: "Century",
    brewery: "Mobberley Brewhouse",
    abv: 5,
    style: "IPA",
    tags: ["hoppy", "balanced", "celebratory"],
    availability: "available",
    tastingNotes: "A celebratory IPA marking the 100th unique beer from this brewery.",
    type: "beer"
  },
  {
    id: "mobberley-cloud-surfer",
    number: 64,
    name: "Cloud Surfer",
    brewery: "Mobberley Brewhouse",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["hoppy", "tropical", "smooth"],
    availability: "available",
    tastingNotes: "A smooth pale ale with tropical hop notes that will take you above the clouds.",
    type: "beer"
  },
  {
    id: "mobberley-decadence",
    number: 65,
    name: "Decadence",
    brewery: "Mobberley Brewhouse",
    abv: 7,
    style: "Imperial Stout",
    tags: ["rich", "chocolate", "complex"],
    availability: "available",
    tastingNotes: "A decadent imperial stout with rich chocolate notes and a complex malt profile.",
    type: "beer"
  },
  {
    id: "mobberley-festival-special",
    number: 66,
    name: "Festival Special",
    brewery: "Mobberley Brewhouse",
    abv: 5,
    style: "Pale Ale",
    tags: ["hoppy", "celebratory", "special"],
    availability: "available",
    tastingNotes: "A special pale ale brewed exclusively for the beer festival.",
    type: "beer"
  },
  {
    id: "mobberley-hazy-daze",
    number: 67,
    name: "Hazy Daze",
    brewery: "Mobberley Brewhouse",
    abv: 5.8,
    style: "IPA",
    tags: ["hazy", "tropical", "juicy"],
    availability: "available",
    tastingNotes: "A hazy IPA with juicy tropical fruit flavors and a smooth mouthfeel.",
    type: "beer"
  },
  {
    id: "mobberley-heritage",
    number: 68,
    name: "Heritage",
    brewery: "Mobberley Brewhouse",
    abv: 4.2,
    style: "Best Bitter",
    tags: ["traditional", "balanced", "malty"],
    availability: "available",
    tastingNotes: "A traditional best bitter celebrating the heritage of English brewing.",
    type: "beer"
  },
  {
    id: "mobberley-helles",
    number: 69,
    name: "Mobberley Helles",
    brewery: "Mobberley Brewhouse",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["clean", "crisp", "malty"],
    availability: "available",
    tastingNotes: "A clean, crisp pale ale inspired by German brewing traditions.",
    type: "beer"
  },
  {
    id: "mobberley-rebellion",
    number: 70,
    name: "Rebellion",
    brewery: "Mobberley Brewhouse",
    abv: 4.4,
    style: "American Pale Ale",
    tags: ["hoppy", "citrus", "crisp"],
    availability: "available",
    tastingNotes: "A crisp American pale ale with bold citrus hop character.",
    type: "beer"
  },
  {
    id: "mobberley-roadside",
    number: 71,
    name: "Roadside IPA",
    brewery: "Mobberley Brewhouse",
    abv: 5.2,
    style: "IPA",
    tags: ["hoppy", "resinous", "balanced"],
    availability: "available",
    tastingNotes: "A balanced IPA with resinous hop character inspired by American craft brewing.",
    type: "beer"
  },
  {
    id: "mobberley-space-invader",
    number: 72,
    name: "Space Invader",
    brewery: "Mobberley Brewhouse",
    abv: 5,
    style: "Pale Ale",
    tags: ["hoppy", "citrus", "crisp"],
    availability: "available",
    tastingNotes: "A crisp, hoppy pale ale with bright citrus notes.",
    type: "beer"
  },
  {
    id: "mobberley-volksbier",
    number: 73,
    name: "Volksbier",
    brewery: "Mobberley Brewhouse",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["clean", "malty", "traditional"],
    availability: "available",
    tastingNotes: "A clean, malty pale ale inspired by German brewing traditions.",
    type: "beer"
  },
  {
    id: "poynton-anson-engine",
    number: 74,
    name: "Anson Engine",
    brewery: "Poynton Brewery",
    abv: 4.5,
    style: "Steam Beer",
    tags: ["malty", "clean", "balanced"],
    availability: "available",
    tastingNotes: "A clean, balanced steam beer named after the local engine house museum.",
    type: "beer"
  },
  {
    id: "poynton-canal-side",
    number: 75,
    name: "Canal Side",
    brewery: "Poynton Brewery",
    abv: 4.1,
    style: "Session Pale",
    tags: ["light", "hoppy", "refreshing"],
    availability: "available",
    tastingNotes: "A light session pale ale perfect for enjoying by the canal.",
    type: "beer"
  },
  {
    id: "poynton-colliery",
    number: 76,
    name: "Colliery Cask",
    brewery: "Poynton Brewery",
    abv: 4,
    style: "Bitter",
    tags: ["traditional", "balanced", "malty"],
    availability: "not_ready",
    tastingNotes: "A traditional bitter paying homage to the local mining heritage.",
    type: "beer"
  },
  {
    id: "poynton-heritage",
    number: 77,
    name: "Heritage",
    brewery: "Poynton Brewery",
    abv: 4,
    style: "Bitter",
    tags: ["traditional", "balanced", "malty"],
    availability: "available",
    tastingNotes: "A traditional bitter celebrating the rich mining heritage of Poynton.",
    type: "beer"
  },
  {
    id: "poynton-higher-lane",
    number: 78,
    name: "Higher Lane",
    brewery: "Poynton Brewery",
    abv: 4.4,
    style: "Pale Ale",
    tags: ["balanced", "citrus", "refreshing"],
    availability: "available",
    tastingNotes: "A balanced pale ale named after a local road, with bright citrus notes.",
    type: "beer"
  },
  {
    id: "poynton-hockley",
    number: 79,
    name: "Hockley Gold",
    brewery: "Poynton Brewery",
    abv: 4.3,
    style: "Golden Ale",
    tags: ["crisp", "honey", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp golden ale with subtle honey notes named after a local area.",
    type: "beer"
  },
  {
    id: "poynton-incline",
    number: 80,
    name: "Incline",
    brewery: "Poynton Brewery",
    abv: 5.2,
    style: "IPA",
    tags: ["hoppy", "resinous", "strong"],
    availability: "available",
    tastingNotes: "A strong IPA with resinous hop character named after the Poynton inclined plane.",
    type: "beer"
  },
  {
    id: "poynton-lady-pit",
    number: 81,
    name: "Lady Pit",
    brewery: "Poynton Brewery",
    abv: 4.2,
    style: "Pale Ale",
    tags: ["hoppy", "floral", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale named after a local coal mine, with floral hop notes.",
    type: "beer"
  },
  {
    id: "poynton-middlewood",
    number: 82,
    name: "Middlewood",
    brewery: "Poynton Brewery",
    abv: 4,
    style: "Blonde Ale",
    tags: ["light", "crisp", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp blonde ale named after the local area, perfect for summer drinking.",
    type: "beer"
  },
  {
    id: "poynton-miners-lamp",
    number: 83,
    name: "Miner's Lamp",
    brewery: "Poynton Brewery",
    abv: 5,
    style: "Dark Ale",
    tags: ["dark", "malty", "smooth"],
    availability: "available",
    tastingNotes: "A smooth dark ale that pays tribute to the mining history of the area.",
    type: "beer"
  },
  {
    id: "poynton-phoenix",
    number: 84,
    name: "Phoenix Rising",
    brewery: "Poynton Brewery",
    abv: 4.3,
    style: "Amber Ale",
    tags: ["malty", "caramel", "balanced"],
    availability: "available",
    tastingNotes: "A balanced amber ale with rich caramel malt character.",
    type: "beer"
  },
  {
    id: "poynton-pit-pony",
    number: 85,
    name: "Pit Pony",
    brewery: "Poynton Brewery",
    abv: 3.8,
    style: "Mild",
    tags: ["dark", "malty", "smooth"],
    availability: "available",
    tastingNotes: "A dark, smooth mild with subtle malt sweetness and low bitterness.",
    type: "beer"
  },
  {
    id: "poynton-sunshine",
    number: 86,
    name: "Sunshine",
    brewery: "Poynton Brewery",
    abv: 4.1,
    style: "Golden Ale",
    tags: ["light", "citrus", "summer"],
    availability: "available",
    tastingNotes: "A bright, refreshing golden ale perfect for sunny days.",
    type: "beer"
  },
  {
    id: "poynton-worth-pit",
    number: 87,
    name: "Worth Pit",
    brewery: "Poynton Brewery",
    abv: 4.8,
    style: "Porter",
    tags: ["roasty", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth porter named after a local coal mine, with rich chocolate notes.",
    type: "beer"
  },
  {
    id: "redwillow-ageless",
    number: 88,
    name: "Ageless",
    brewery: "RedWillow Brewery",
    abv: 4.7,
    style: "Best Bitter",
    tags: ["traditional", "timeless", "balanced"],
    availability: "available",
    tastingNotes: "A timeless best bitter with perfect balance - some things never go out of style.",
    type: "beer"
  },
  {
    id: "redwillow-directionless",
    number: 89,
    name: "Directionless",
    brewery: "RedWillow Brewery",
    abv: 4.5,
    style: "IPA",
    tags: ["hoppy", "citrus", "pine"],
    availability: "not_ready",
    tastingNotes: "A modern IPA with bold citrus and pine hop character.",
    type: "beer"
  },
  {
    id: "redwillow-endless",
    number: 90,
    name: "Endless",
    brewery: "RedWillow Brewery",
    abv: 3.8,
    style: "Session Pale",
    tags: ["hoppy", "light", "sessionable"],
    availability: "available",
    tastingNotes: "A light session pale ale that you can enjoy endlessly.",
    type: "beer"
  },
  {
    id: "redwillow-faithless",
    number: 91,
    name: "Faithless",
    brewery: "RedWillow Brewery",
    abv: 4.7,
    style: "IPA",
    tags: ["hoppy", "citrus", "zesty"],
    availability: "available",
    tastingNotes: "A zesty IPA with bold citrus hop character and a dry finish.",
    type: "beer"
  },
  {
    id: "redwillow-fathomless",
    number: 92,
    name: "Fathomless",
    brewery: "RedWillow Brewery",
    abv: 6.5,
    style: "Porter",
    tags: ["coffee", "chocolate", "complex"],
    availability: "available",
    tastingNotes: "A complex porter with rich coffee and dark chocolate notes.",
    type: "beer"
  },
  {
    id: "redwillow-fearless",
    number: 93,
    name: "Fearless",
    brewery: "RedWillow Brewery",
    abv: 6,
    style: "IPA",
    tags: ["hoppy", "bold", "tropical"],
    availability: "available",
    tastingNotes: "A bold IPA with fearless tropical hop character and a dry finish.",
    type: "beer"
  },
  {
    id: "redwillow-headless",
    number: 94,
    name: "Headless",
    brewery: "RedWillow Brewery",
    abv: 3.9,
    style: "Bitter",
    tags: ["malty", "balanced", "traditional"],
    availability: "sold_out",
    tastingNotes: "A traditional English bitter with a balanced malt profile.",
    type: "beer"
  },
  {
    id: "redwillow-peerless",
    number: 95,
    name: "Peerless",
    brewery: "RedWillow Brewery",
    abv: 3.8,
    style: "Session IPA",
    tags: ["hoppy", "light", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing session IPA that stands above the rest.",
    type: "beer"
  },
  {
    id: "redwillow-restless",
    number: 96,
    name: "Restless",
    brewery: "RedWillow Brewery",
    abv: 4.4,
    style: "Session IPA",
    tags: ["hoppy", "light", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing session IPA that will keep you coming back for more.",
    type: "beer"
  },
  {
    id: "redwillow-shameless",
    number: 97,
    name: "Shameless",
    brewery: "RedWillow Brewery",
    abv: 5.9,
    style: "IPA",
    tags: ["hoppy", "strong", "bold"],
    availability: "available",
    tastingNotes: "A bold, strong IPA that's not afraid to show off its hop character.",
    type: "beer"
  },
  {
    id: "redwillow-sleepless",
    number: 98,
    name: "Sleepless",
    brewery: "RedWillow Brewery",
    abv: 5.5,
    style: "IPA",
    tags: ["hoppy", "pine", "resinous"],
    availability: "available",
    tastingNotes: "A bold IPA with pine and resinous hop character that will keep you up all night.",
    type: "beer"
  },
  {
    id: "redwillow-smokeless",
    number: 99,
    name: "Smokeless",
    brewery: "RedWillow Brewery",
    abv: 5.7,
    style: "Smoked Porter",
    tags: ["smoky", "chocolate", "complex"],
    availability: "available",
    tastingNotes: "A complex porter with subtle smoke character and rich chocolate notes.",
    type: "beer"
  },
  {
    id: "redwillow-soulless",
    number: 100,
    name: "Soulless",
    brewery: "RedWillow Brewery",
    abv: 6.8,
    style: "Black IPA",
    tags: ["hoppy", "roasty", "complex"],
    availability: "available",
    tastingNotes: "A complex black IPA with bold hop character and subtle roasted notes.",
    type: "beer"
  },
  {
    id: "redwillow-thoughtless",
    number: 101,
    name: "Thoughtless",
    brewery: "RedWillow Brewery",
    abv: 4.2,
    style: "Session IPA",
    tags: ["hoppy", "light", "easy"],
    availability: "available",
    tastingNotes: "A light session IPA that's easy drinking and doesn't require much thought.",
    type: "beer"
  },
  {
    id: "redwillow-weightless",
    number: 102,
    name: "Weightless",
    brewery: "RedWillow Brewery",
    abv: 4.2,
    style: "Pale Ale",
    tags: ["hoppy", "floral", "balanced"],
    availability: "available",
    tastingNotes: "A well-balanced pale ale with floral hop character and a clean finish.",
    type: "beer"
  },
  {
    id: "redwillow-wreckless",
    number: 103,
    name: "Wreckless",
    brewery: "RedWillow Brewery",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["hoppy", "tropical", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale with tropical hop notes and a clean finish.",
    type: "beer"
  },
  {
    id: "storm-bosley-cloud",
    number: 104,
    name: "Bosley Cloud",
    brewery: "Storm Brewing",
    abv: 4.1,
    style: "Bitter",
    tags: ["malty", "balanced", "traditional"],
    availability: "available",
    tastingNotes: "A classic English bitter named after the local landmark.",
    type: "beer"
  },
  {
    id: "storm-calm-before",
    number: 105,
    name: "Calm Before",
    brewery: "Storm Brewing",
    abv: 4,
    style: "Pale Ale",
    tags: ["balanced", "light", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing pale ale - the calm before the storm of flavor.",
    type: "beer"
  },
  {
    id: "storm-cloud-burst",
    number: 106,
    name: "Cloud Burst",
    brewery: "Storm Brewing",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["hoppy", "tropical", "juicy"],
    availability: "available",
    tastingNotes: "A juicy pale ale with tropical hop notes that burst with flavor.",
    type: "beer"
  },
  {
    id: "storm-downpour",
    number: 107,
    name: "Downpour",
    brewery: "Storm Brewing",
    abv: 5,
    style: "IPA",
    tags: ["hoppy", "juicy", "tropical"],
    availability: "available",
    tastingNotes: "A juicy IPA with tropical hop notes that pour down like a summer storm.",
    type: "beer"
  },
  {
    id: "storm-eye-of-storm",
    number: 108,
    name: "Eye of the Storm",
    brewery: "Storm Brewing",
    abv: 4.8,
    style: "Session IPA",
    tags: ["hoppy", "balanced", "sessionable"],
    availability: "available",
    tastingNotes: "A balanced session IPA that provides calm amidst the storm of flavor.",
    type: "beer"
  },
  {
    id: "storm-gale-force",
    number: 109,
    name: "Gale Force",
    brewery: "Storm Brewing",
    abv: 6.8,
    style: "Strong Ale",
    tags: ["strong", "rich", "warming"],
    availability: "available",
    tastingNotes: "A powerful strong ale that will blow you away with rich malt character.",
    type: "beer"
  },
  {
    id: "storm-hurricane",
    number: 110,
    name: "Hurricane",
    brewery: "Storm Brewing",
    abv: 6,
    style: "IPA",
    tags: ["hoppy", "strong", "resinous"],
    availability: "available",
    tastingNotes: "A strong IPA with bold hop character and a resinous finish.",
    type: "beer"
  },
  {
    id: "storm-lightning",
    number: 111,
    name: "Lightning",
    brewery: "Storm Brewing",
    abv: 4.5,
    style: "Blonde Ale",
    tags: ["light", "crisp", "zesty"],
    availability: "available",
    tastingNotes: "A bright, zesty blonde ale that strikes with refreshing flavor.",
    type: "beer"
  },
  {
    id: "storm-perfect-storm",
    number: 112,
    name: "Perfect Storm",
    brewery: "Storm Brewing",
    abv: 5.5,
    style: "IPA",
    tags: ["hoppy", "balanced", "complex"],
    availability: "available",
    tastingNotes: "A perfectly balanced IPA with complex hop character - the perfect storm of flavor.",
    type: "beer"
  },
  {
    id: "storm-rainstorm",
    number: 113,
    name: "Rainstorm",
    brewery: "Storm Brewing",
    abv: 4.3,
    style: "Session IPA",
    tags: ["hoppy", "light", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing session IPA to enjoy during a typical British downpour.",
    type: "beer"
  },
  {
    id: "storm-red-mist",
    number: 114,
    name: "Red Mist",
    brewery: "Storm Brewing",
    abv: 4.5,
    style: "Red Ale",
    tags: ["malty", "caramel", "balanced"],
    availability: "available",
    tastingNotes: "A ruby-red ale with rich caramel malt character and a balanced finish.",
    type: "beer"
  },
  {
    id: "storm-silk-of-amnesia",
    number: 115,
    name: "Silk of Amnesia",
    brewery: "Storm Brewing",
    abv: 3.8,
    style: "Bitter",
    tags: ["malty", "caramel", "traditional"],
    availability: "available",
    tastingNotes: "A traditional English bitter with caramel notes and a gentle bitterness.",
    type: "beer"
  },
  {
    id: "storm-breeze",
    number: 116,
    name: "Summer Breeze",
    brewery: "Storm Brewing",
    abv: 3.9,
    style: "Blonde Ale",
    tags: ["light", "refreshing", "citrus"],
    availability: "available",
    tastingNotes: "A light, refreshing blonde ale with subtle citrus notes perfect for summer.",
    type: "beer"
  },
  {
    id: "storm-thunder",
    number: 117,
    name: "Thunder",
    brewery: "Storm Brewing",
    abv: 5.8,
    style: "Stout",
    tags: ["rich", "chocolate", "complex"],
    availability: "available",
    tastingNotes: "A powerful stout with rich chocolate flavors and a complex malt profile.",
    type: "beer"
  },
  {
    id: "storm-wildcat",
    number: 118,
    name: "Wildcat",
    brewery: "Storm Brewing",
    abv: 5.8,
    style: "IPA",
    tags: ["hoppy", "fierce", "citrus"],
    availability: "available",
    tastingNotes: "A fierce IPA with bold citrus hop character that will scratch your hop itch.",
    type: "beer"
  },
  {
    id: "storm-winter-storm",
    number: 119,
    name: "Winter Storm",
    brewery: "Storm Brewing",
    abv: 5.5,
    style: "Winter Ale",
    tags: ["spicy", "warming", "rich"],
    availability: "not_ready",
    tastingNotes: "A warming winter ale with subtle spice notes perfect for cold evenings.",
    type: "beer"
  },
  {
    id: "tatton-barrel-aged",
    number: 120,
    name: "Barrel Aged Imperial",
    brewery: "Tatton Brewery",
    abv: 9,
    style: "Imperial Stout",
    tags: ["rich", "complex", "oak"],
    availability: "available",
    tastingNotes: "A rich, complex imperial stout aged in whiskey barrels for added depth.",
    type: "beer"
  },
  {
    id: "tatton-best-bitter",
    number: 121,
    name: "Best Bitter",
    brewery: "Tatton Brewery",
    abv: 4.2,
    style: "Bitter",
    tags: ["traditional", "balanced", "malty"],
    availability: "available",
    tastingNotes: "A classic English best bitter with a perfect balance of malt and hop character.",
    type: "beer"
  },
  {
    id: "tatton-cider",
    number: 122,
    name: "Cheshire Cider",
    brewery: "Tatton Brewery",
    abv: 5,
    style: "Cider",
    tags: ["apple", "crisp", "dry"],
    availability: "available",
    tastingNotes: "A crisp, dry cider made with Cheshire apples.",
    type: "cider"
  },
  {
    id: "tatton-perry",
    number: 123,
    name: "Cheshire Perry",
    brewery: "Tatton Brewery",
    abv: 5.2,
    style: "Perry",
    tags: ["pear", "sweet", "refreshing"],
    availability: "available",
    tastingNotes: "A sweet, refreshing perry made with local Cheshire pears.",
    type: "cider"
  },
  {
    id: "tatton-cheshire-pilsner",
    number: 124,
    name: "Cheshire Pilsner",
    brewery: "Tatton Brewery",
    abv: 4.8,
    style: "Pilsner",
    tags: ["crisp", "clean", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp, clean pilsner with a refreshing finish brewed in the heart of Cheshire.",
    type: "beer"
  },
  {
    id: "tatton-cheshire-stout",
    number: 125,
    name: "Cheshire Stout",
    brewery: "Tatton Brewery",
    abv: 4.8,
    style: "Stout",
    tags: ["roasty", "smooth", "chocolate"],
    availability: "available",
    tastingNotes: "A smooth stout celebrating Cheshire with subtle chocolate notes.",
    type: "beer"
  },
  {
    id: "tatton-lazy-haze",
    number: 126,
    name: "Lazy Haze",
    brewery: "Tatton Brewery",
    abv: 4.8,
    style: "Pale Ale",
    tags: ["hazy", "fruity", "smooth"],
    availability: "available",
    tastingNotes: "A hazy pale ale with smooth mouthfeel and fruity hop character.",
    type: "beer"
  },
  {
    id: "tatton-obscure",
    number: 127,
    name: "Obscure",
    brewery: "Tatton Brewery",
    abv: 5.7,
    style: "IPA",
    tags: ["hoppy", "fruity", "complex"],
    availability: "available",
    tastingNotes: "A complex IPA with layers of fruity hop character.",
    type: "beer"
  },
  {
    id: "tatton-railway-porter",
    number: 128,
    name: "Railway Porter",
    brewery: "Tatton Brewery",
    abv: 4.9,
    style: "Porter",
    tags: ["roasty", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth porter inspired by the railway heritage of Cheshire.",
    type: "beer"
  },
  {
    id: "tatton-rhubarb-cider",
    number: 129,
    name: "Rhubarb Cider",
    brewery: "Tatton Brewery",
    abv: 4,
    style: "Fruit Cider",
    tags: ["rhubarb", "tart", "refreshing"],
    availability: "available",
    tastingNotes: "A refreshing cider with tart rhubarb character, a local specialty.",
    type: "cider"
  },
  {
    id: "tatton-seasonal",
    number: 130,
    name: "Seasonal Special",
    brewery: "Tatton Brewery",
    abv: 5,
    style: "IPA",
    tags: ["seasonal", "limited", "special"],
    availability: "available",
    tastingNotes: "A special seasonal IPA with unique hop combinations that change throughout the year.",
    type: "beer"
  },
  {
    id: "tatton-special-reserve",
    number: 131,
    name: "Special Reserve",
    brewery: "Tatton Brewery",
    abv: 6,
    style: "Strong Ale",
    tags: ["rich", "complex", "premium"],
    availability: "available",
    tastingNotes: "A premium strong ale with rich, complex malt character aged in oak barrels.",
    type: "beer"
  },
  {
    id: "tatton-summer-blonde",
    number: 132,
    name: "Summer Blonde",
    brewery: "Tatton Brewery",
    abv: 4,
    style: "Blonde Ale",
    tags: ["light", "refreshing", "citrus"],
    availability: "available",
    tastingNotes: "A light, refreshing blonde ale with subtle citrus notes perfect for summer.",
    type: "beer"
  },
  {
    id: "tatton-gold",
    number: 133,
    name: "Tatton Gold",
    brewery: "Tatton Brewery",
    abv: 4.8,
    style: "Golden Ale",
    tags: ["balanced", "honey", "crisp"],
    availability: "available",
    tastingNotes: "A crisp golden ale with subtle honey notes and a refreshing finish.",
    type: "beer"
  },
  {
    id: "tatton-white-queen",
    number: 134,
    name: "White Queen",
    brewery: "Tatton Brewery",
    abv: 4.2,
    style: "Wheat Beer",
    tags: ["wheat", "spicy", "refreshing"],
    availability: "available",
    tastingNotes: "A refreshing wheat beer with subtle spice notes and a clean finish.",
    type: "beer"
  },
  {
    id: "wincle-banker",
    number: 135,
    name: "Banker's Draft",
    brewery: "Wincle Beer Co",
    abv: 4.1,
    style: "Golden Ale",
    tags: ["crisp", "light", "refreshing"],
    availability: "available",
    tastingNotes: "A crisp, refreshing golden ale that won't break the bank.",
    type: "beer"
  },
  {
    id: "wincle-body-snatcher",
    number: 136,
    name: "Body Snatcher",
    brewery: "Wincle Beer Co",
    abv: 4.3,
    style: "Pale Ale",
    tags: ["hoppy", "citrus", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale with citrus hop notes and a clean finish.",
    type: "beer"
  },
  {
    id: "wincle-cheshire-cheese",
    number: 137,
    name: "Cheshire Cheese",
    brewery: "Wincle Beer Co",
    abv: 4.3,
    style: "Golden Ale",
    tags: ["balanced", "malty", "smooth"],
    availability: "available",
    tastingNotes: "A smooth golden ale that pairs perfectly with local Cheshire cheese.",
    type: "beer"
  },
  {
    id: "wincle-dancing-trout",
    number: 138,
    name: "Dancing Trout",
    brewery: "Wincle Beer Co",
    abv: 4.2,
    style: "Golden Ale",
    tags: ["light", "refreshing", "summer"],
    availability: "available",
    tastingNotes: "A light, refreshing golden ale inspired by the trout in the local river.",
    type: "beer"
  },
  {
    id: "wincle-macclesfield-forest",
    number: 139,
    name: "Macclesfield Forest",
    brewery: "Wincle Beer Co",
    abv: 4.8,
    style: "Dark Ale",
    tags: ["malty", "earthy", "complex"],
    availability: "available",
    tastingNotes: "A complex dark ale inspired by the nearby forest with earthy hop notes.",
    type: "beer"
  },
  {
    id: "wincle-old-hag",
    number: 140,
    name: "Old Hag",
    brewery: "Wincle Beer Co",
    abv: 5.2,
    style: "Stout",
    tags: ["roasty", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth, full-bodied stout with rich roasted malt character.",
    type: "beer"
  },
  {
    id: "wincle-peak-district",
    number: 141,
    name: "Peak District Pale",
    brewery: "Wincle Beer Co",
    abv: 4.5,
    style: "Pale Ale",
    tags: ["hoppy", "floral", "balanced"],
    availability: "available",
    tastingNotes: "A balanced pale ale inspired by the beautiful Peak District landscape.",
    type: "beer"
  },
  {
    id: "wincle-rambler",
    number: 142,
    name: "Rambler",
    brewery: "Wincle Beer Co",
    abv: 4,
    style: "Session IPA",
    tags: ["light", "hoppy", "refreshing"],
    availability: "available",
    tastingNotes: "A light, refreshing session IPA perfect for after a long walk in the countryside.",
    type: "beer"
  },
  {
    id: "wincle-river-runner",
    number: 143,
    name: "River Runner",
    brewery: "Wincle Beer Co",
    abv: 4.2,
    style: "Golden Ale",
    tags: ["crisp", "refreshing", "light"],
    availability: "available",
    tastingNotes: "A crisp, refreshing golden ale inspired by the local river.",
    type: "beer"
  },
  {
    id: "wincle-river-wild",
    number: 144,
    name: "River Wild",
    brewery: "Wincle Beer Co",
    abv: 5.2,
    style: "Sour Ale",
    tags: ["sour", "fruity", "wild"],
    availability: "available",
    tastingNotes: "A wild sour ale with fruity notes inspired by the local river.",
    type: "beer"
  },
  {
    id: "wincle-undertaker",
    number: 145,
    name: "Undertaker",
    brewery: "Wincle Beer Co",
    abv: 5.5,
    style: "Porter",
    tags: ["roasty", "chocolate", "smooth"],
    availability: "available",
    tastingNotes: "A smooth porter with rich chocolate and roasted malt character.",
    type: "beer"
  },
  {
    id: "wincle-waller-extra",
    number: 146,
    name: "Waller's Extra",
    brewery: "Wincle Beer Co",
    abv: 5,
    style: "Strong Mild",
    tags: ["malty", "rich", "smooth"],
    availability: "available",
    tastingNotes: "A stronger version of the classic mild with rich malt character.",
    type: "beer"
  },
  {
    id: "wincle-waller",
    number: 147,
    name: "Waller's Mild",
    brewery: "Wincle Beer Co",
    abv: 3.6,
    style: "Mild",
    tags: ["malty", "smooth", "light"],
    availability: "available",
    tastingNotes: "A traditional mild with subtle malt sweetness and a light body.",
    type: "beer"
  },
  {
    id: "wincle-wibbly-wallaby",
    number: 148,
    name: "Wibbly Wallaby",
    brewery: "Wincle Beer Co",
    abv: 4,
    style: "Blonde Ale",
    tags: ["light", "malty", "smooth"],
    availability: "available",
    tastingNotes: "A smooth, easy-drinking blonde ale with subtle malt sweetness.",
    type: "beer"
  },
  {
    id: "wincle-wibbly-wallaby-extra",
    number: 149,
    name: "Wibbly Wallaby Extra",
    brewery: "Wincle Beer Co",
    abv: 5,
    style: "Strong Blonde",
    tags: ["light", "strong", "smooth"],
    availability: "available",
    tastingNotes: "A stronger version of the popular blonde ale with more body and character.",
    type: "beer"
  },
  {
    id: "wincle-wincle-waller",
    number: 150,
    name: "Wincle Waller",
    brewery: "Wincle Beer Co",
    abv: 4,
    style: "Session Bitter",
    tags: ["balanced", "traditional", "sessionable"],
    availability: "available",
    tastingNotes: "A sessionable bitter with perfect balance for all-day drinking.",
    type: "beer"
  }
];
